import * as React from "react";
import { SVGProps } from "react";
export const BuildingIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <mask
            id="mask0_11068_94196"
            style={{
                maskType: "alpha",
            }}
            maskUnits="userSpaceOnUse"
            x={0}
            y={0}
            width={20}
            height={20}
        >
            <rect width={20} height={20} fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_11068_94196)">
            <path
                d="M4.25 17.5C3.76875 17.5 3.35677 17.3286 3.01406 16.9859C2.67135 16.6432 2.5 16.2312 2.5 15.75V7.5625C2.5 7.08125 2.67135 6.66927 3.01406 6.32656C3.35677 5.98385 3.76875 5.8125 4.25 5.8125H5.8125V4.25C5.8125 3.76875 5.98385 3.35677 6.32656 3.01406C6.66927 2.67135 7.08125 2.5 7.5625 2.5H12.4375C12.9187 2.5 13.3307 2.67135 13.6734 3.01406C14.0161 3.35677 14.1875 3.76875 14.1875 4.25V9.125H15.75C16.2312 9.125 16.6432 9.29635 16.9859 9.63906C17.3286 9.98177 17.5 10.3938 17.5 10.875V15.75C17.5 16.2312 17.3286 16.6432 16.9859 16.9859C16.6432 17.3286 16.2312 17.5 15.75 17.5H10.875V14.1875H9.125V17.5H4.25ZM4.25 15.75H5.8125V14.1875H4.25V15.75ZM4.25 12.4375H5.8125V10.875H4.25V12.4375ZM4.25 9.125H5.8125V7.5625H4.25V9.125ZM7.5625 12.4375H9.125V10.875H7.5625V12.4375ZM7.5625 9.125H9.125V7.5625H7.5625V9.125ZM7.5625 5.8125H9.125V4.25H7.5625V5.8125ZM10.875 12.4375H12.4375V10.875H10.875V12.4375ZM10.875 9.125H12.4375V7.5625H10.875V9.125ZM10.875 5.8125H12.4375V4.25H10.875V5.8125ZM14.1875 15.75H15.75V14.1875H14.1875V15.75ZM14.1875 12.4375H15.75V10.875H14.1875V12.4375Z"
                fill="currentColor"
            />
        </g>
    </svg>
);
BuildingIcon.displayName = "BuildingIcon";
